import { apiClient } from "../common/apiClient";
import { APIPROXY_HOST } from "../common/environment";
import { reportError } from "../common/errorReporting";
import toastStore from "../stores/toastStore";
import type { MockScenarioName, Scenario } from "./types";

// The errors fire a few seconds after startup, once PostHog captures errors and a session recording has some lead-up
export const ERROR_SCENARIO_DELAY_MS = 5000;

// Answered with a 500 by the errorHandled mock handler. Deliberately not in platformRoutes, which lists real platform
// paths only; this endpoint exists only in the mocks, and the request and its handler already share this constant.
export const HANDLED_ERROR_SCENARIO_URL = `${APIPROXY_HOST}/api/backend/mock/error-scenario`;

export const startErrorScenarios = (scenarios: Scenario[]) => {
   const runLater = (scenario: MockScenarioName, run: () => void) => {
      if (scenarios.includes(scenario)) {
         setTimeout(run, ERROR_SCENARIO_DELAY_MS);
      }
   };

   runLater("errorUnhandled", () => {
      throw new Error("Mock scenario errorUnhandled: unhandled error");
   });
   runLater("errorRejection", () => {
      void Promise.reject(new Error("Mock scenario errorRejection: unhandled promise rejection"));
   });
   runLater("errorHandled", () => {
      // The password in the query string checks that the reported request URL leaves it out
      void apiClient(`${HANDLED_ERROR_SCENARIO_URL}?password=not-a-real-password`)
         .get()
         .res()
         .catch((err) => reportError(err, { context: "Mock scenario errorHandled" }));
   });
   runLater("errorToast", () => {
      toastStore.addError("Mock scenario errorToast", "Denne feilmeldingen kommer fra mock-scenarioet errorToast.");
   });
};
